import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Tooltip } from '@fiverr-private/fit';
import Avatar from '../../Avatar';
import CollaboratorShape from '../../../PropsShape/CollaboratorShape';
import { getActiveParticipatorsByCurrentGroup } from '../../../selectors/collaborators';

import './style.scss';

const numberOfAvatarsWithoutDrawer = 4;
const numberOfAvatarsWithDrawer = 3;

const CollaboratorsDrawer = ({ collaborators, standalone }) => (
    <div className="plus-collaborator font-accent">
        +{collaborators.length - numberOfAvatarsWithDrawer}
        <div className="drawer-container">
            <ul className="collaborators-drawer">
                {collaborators.map((collaborator) => {
                    const { username, id, userImage, email, fullName } = collaborator;
                    let collaboratorName = username ? username : email;

                    if (standalone && fullName) {
                        collaboratorName = fullName;
                    }

                    return (
                        <li key={id}>
                            <Avatar username={collaboratorName} src={userImage} className="avatar-collaborator-drawer"/>
                            <span className="collaborator-name">{collaboratorName}</span>
                        </li>
                    );
                })}
            </ul>
        </div>
    </div>
);

CollaboratorsDrawer.propTypes = {
    collaborators: PropTypes.arrayOf(CollaboratorShape).isRequired,
    standalone: PropTypes.bool
};

const Avatars = ({ collaborators, standalone }) => {
    if (!collaborators.length) { return null; }

    const shouldShowDrawer = collaborators.length > numberOfAvatarsWithoutDrawer;
    const newCollaborators = collaborators.slice(0, shouldShowDrawer ? numberOfAvatarsWithDrawer : numberOfAvatarsWithoutDrawer);

    return (
        <div className="profile-picture-container">
            {newCollaborators.map((collaborator, idx) => {
                const { username, userImage, email } = collaborator;
                const collaboratorName = username ? username : email;

                return (
                    <div key={idx}>
                        <Tooltip content={collaboratorName} delay={true}>
                            <Avatar className="avatar-header"
                                username={collaboratorName}
                                src={userImage}
                                size={30}/>
                        </Tooltip>
                    </div>
                );
            })}

            {shouldShowDrawer && <CollaboratorsDrawer collaborators={collaborators} standalone={standalone}/>}
        </div>
    );
};

Avatars.defaultProps = {
    collaborators: [],
    standalone: false
};

Avatars.propTypes = {
    collaborators: PropTypes.arrayOf(CollaboratorShape),
    standalone: PropTypes.bool
};

const mapStateToProps = (state) => ({
    collaborators: getActiveParticipatorsByCurrentGroup(state)
});

export default connect(mapStateToProps)(Avatars);
